import { render } from "./ActionElement.vue?vue&type=template&id=c0f04732&scoped=true"
import script from "./ActionElement.vue?vue&type=script&lang=js"
export * from "./ActionElement.vue?vue&type=script&lang=js"

import "./ActionElement.vue?vue&type=style&index=0&id=c0f04732&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f04732"]])

export default __exports__